import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { TrustHomepageSections } from '../components/TrustHomepageSections';
import { MarketingHead } from '../components/marketing/MarketingHead';

const HOME_HEAD = {
  title: 'IA para atención al cliente conectada a tu negocio | Áncora Automations',
  description:
    'Tu empleado digital que atiende y gestiona el día a día del negocio de principio a fin, ocupándose de las tareas repetitivas.',
  imagePath: '/og-image.png',
  imageAlt: 'Áncora Automations, IA para atención al cliente conectada a tu negocio',
  schema: {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Áncora Automations',
    url: 'https://www.ancoraautomations.es/',
    description:
      'IA para atender a tus clientes, consultar la información de tu negocio y continuar el trabajo después de cada conversación.',
    publisher: {
      '@type': 'Organization',
      name: 'Áncora Automations',
      url: 'https://www.ancoraautomations.es/',
      logo: 'https://www.ancoraautomations.es/logo-ancora-corporate.png',
    },
  },
} as const;

export const Home: React.FC = () => {
  return (
    <div className="marketing-shell" data-surface="marketing-home">
      <MarketingHead path="/" {...HOME_HEAD} />
      <HeroSection />
      <TrustHomepageSections />
    </div>
  );
};